import { ActionType } from '../constants/modalConstants';

export const openResortModal = () => ({
  type: ActionType.OPEN_RESORT_MODAL,
});

export const closeResortModal = () => ({
  type: ActionType.CLOSE_RESORT_MODAL,
});

export const openDrawInstruments = () => ({
  type: ActionType.OPEN_DRAW_INSTRUMENTS,
});

export const closeDrawInstruments = () => ({
  type: ActionType.CLOSE_DRAW_INSTRUMENTS,
});
